
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/formulario-seja-parceiro",
      function () {
        return require("private-next-pages/formulario-seja-parceiro/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/formulario-seja-parceiro"])
      });
    }
  